// src/diagnostics.js
// A short memory of what went wrong (and of the important steps) in this run of the app, so that a problem inside the phone app,
// where there is no developer console, can be looked at: the "Diagnostics" pill (components/DiagnosticsPill.jsx) shows it.
const MAX = 120;
const entries = [];
const listeners = new Set();
let installed = false;

const stamp = () => new Date().toISOString().slice(11, 19);

// level: 'info' | 'warn' | 'error'
export function diag(level, text) {
    entries.push({ at: stamp(), level, text: String(text).slice(0, 600) });
    if (entries.length > MAX) entries.shift();
    listeners.forEach((listener) => listener(entries));
}

export const diagnosticEntries = () => entries;

export function subscribeToDiagnostics(listener) {
    listeners.add(listener);
    return () => listeners.delete(listener);
}

const describe = (value) => {
    if (value && value.message) return `${value.message}${value.stack ? ' | ' + String(value.stack).split('\n').slice(0, 2).join(' / ') : ''}`;
    try {
        return typeof value === 'string' ? value : JSON.stringify(value);
    } catch (error) {
        return String(value);
    }
};

// Also keeps what the app itself logs as errors and warnings, and errors nobody caught.
export function installDiagnostics() {
    if (installed || typeof window === 'undefined') return;
    installed = true;
    ['error', 'warn'].forEach((level) => {
        const original = console[level].bind(console);
        console[level] = (...args) => {
            diag(level, args.map(describe).join(' '));
            original(...args);
        };
    });
    window.addEventListener('error', (event) => diag('error', `uncaught: ${describe(event.error || event.message)}`));
    window.addEventListener('unhandledrejection', (event) => diag('error', `unhandled: ${describe(event.reason)}`));
}
